import _ from 'lodash'
import request from './request'

export default {
  name: 'KUpload',
  components: {},
  mixins: [],
  props: {
    className: {
      type: String,
    },
    url: {
      type: String,
      default: '',
    },
    /**
     * 文件大小限制, 单位 kb, 默认 1 m
     */
    maxSize: {
      type: Number,
      default: 1 * 1024,
    },
    /**
     * 允许文件扩展名, 例如 ["jpg", "jpeg", "png", "gif"]
     */
    ext: {
      type: Array,
      default() {
        return ['jpg', 'jpeg', 'png', 'gif']
      },
    },
    accept: {
      type: String,
      default: '',
    },
    multiple: Boolean,
    withCredentials: {
      type: Boolean,
      default: true,
    },
    name: {
      type: String,
      default: 'file',
    },
    data: {
      type: Object,
      // {}
      default() {
        return {}
      },
    },
    fileList: {
      type: Array,
      // []
      default() {
        return []
      },
    },
    autoUpload: {
      type: Boolean,
      default: true,
    },
    beforeUpload: {
      type: Function,
      default: _.noop,
    },
    onChange: {
      type: Function,
      default: _.noop,
    },
    onSuccess: {
      type: Function,
      default: _.noop,
    },
    onError: {
      type: Function,
      default: _.noop,
    },
    onExtError: {
      type: Function,
      default: undefined,
    },
    onSizeError: {
      type: Function,
      default: undefined,
    },
    onProgress: {
      type: Function,
      default: _.noop,
    },
    onLoadStart: {
      type: Function,
      default: _.noop,
    },
    onLoadEnd: {
      type: Function,
      default: _.noop,
    },
    disabled: Boolean,
    headers: {
      type: Object,
      default: () => ({}),
    },
    // multiple 多选时，限制上传个数
    limitNumber: {
      type: Number,
      default: null,
    },
    // 超出上传个数时的钩子函数
    onExceed: {
      type: Function,
      default: undefined,
    },
  },
  data() {
    return {
      reqStore: {},
      file: {},
    }
  },
  computed: {},
  watch: {},
  methods: {
    handleClick() {
      if (this.disabled) return
      this.$refs.input.value = null
      this.$refs.input.click()
    },
    handleChange(e) {
      const files = e.target.files
      if (this.limitNumber && files.length + this.fileList.length > this.limitNumber) {
        if (this.onExceed) {
          this.onExceed(files)
        } else {
          this.$message({
            type: 'warning',
            message: `超过最大上传数量，请上传 ${this.limitNumber} 个以下的文件。`,
          })
        }
        return
      }
      if (files.length) {
        _.each(files, (item) => {
          this.changeFile(item)
        })
      }
    },
    async changeFile(files) {
      const file = files

      // 判断文件大小
      if ((file.size / 1024) > this.maxSize) {
        if (this.onSizeError) {
          this.onSizeError(file)
        } else {
          let sizeStr = ''
          if (this.maxSize < 1024) {
            sizeStr = `${this.maxSize}KB`
          } else {
            let maxSizeInM = this.maxSize / 1024
            maxSizeInM = +maxSizeInM.toFixed(0) === +maxSizeInM.toFixed(1) ? maxSizeInM.toFixed(0)
              : maxSizeInM.toFixed(1)
            sizeStr = `${maxSizeInM}M`
          }
          this.$message({
            type: 'warning',
            message: `上传文件不能超过 ${sizeStr}`,
          })
        }
        return
      }

      // 判断文件类型
      let type = file.type.split('/')[1] || file.type.split('/')[0]
      if (type === 'jpeg') {
        type = 'jpg'
      }
      if (this.ext.indexOf(type) === -1) {
        if (this.onExtError) {
          this.onExtError(file)
        } else {
          this.$message({
            type: 'warning',
            message: `文件格式不正确，请选择 ${this.ext.join('，')} 类型`,
          })
        }
        return
      }

      this.file = file

      if (this.onChange) {
        try {
          await this.onChange(file)
        } catch (e) {
          this.$message({
            type: 'warning',
            message: (e && e.message) || e,
          })
          return
        }
      }

      if (this.autoUpload) {
        this.upload(file)
      } else {
        const reads = new FileReader()
        reads.readAsDataURL(file)
        const _this = this
        reads.onload = function () {
          _this.onSuccess({
            data: [{
              name: file.name,
              url: this.result,
            }],
            message: '',
            type: 'localPreview',
            code: 0,
          }, file)
        }
      }
    },
    async upload(crop) {
      if (this.beforeUpload) {
        try {
          await this.beforeUpload()
        } catch (e) {
          this.$message({
            type: 'warning',
            message: (e && e.message) || e,
          })
          return
        }
      }
      const file = crop || this.file
      const { uid } = file

      const opts = {
        url: this.url,
        headers: _.assign({}, this.headers),
        withCredentials: this.withCredentials,
        data: Object.assign({ crop: JSON.stringify(crop) }, this.data),
        name: this.name,
        file,
        onSuccess: res => {
          this.onSuccess(res, file)
          delete this.reqStore[uid]
        },
        onError: err => {
          this.onError(err, file)
          delete this.reqStore[uid]
        },
        onProgress: e => {
          file.percent = e.percent
          this.onProgress(e, file)
        },
        onloadend: e => {
          this.onLoadEnd(e, file)
        },
        onloadstart: e => {
          this.onLoadStart(e, file)
        },
      }
      const req = request(opts)
      this.reqStore[uid] = req
      if (req && req.then) {
        req.then(opts.onSuccess, opts.onError)
      }
      return req
    },
  },
  render() {
    const { name, multiple, accept, handleClick, handleChange } = this
    const data = {
      class: {
        'km-upload': true,
      },
      attrs: {
        tabIndex: 0,
      },
      on: {
        click: handleClick,
      },
    }
    return (
      <div {...data}>
        {this.$slots.default}
        <input
          class="km-upload__input"
          type="file"
          ref="input"
          name={name}
          multiple={multiple}
          accept={accept}
          on-change={handleChange}
        />
      </div>
    )
  },
}
